// extracted by mini-css-extract-plugin
module.exports = {"tabLines":"RtjGzXys"};